import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SHARED_LIB_CONFIG, SharedLibConfig } from "../config/lib-config";

@Injectable({
    providedIn: 'root',
})

export class AttributeDefinitionService {
    private pathApi: string;
    constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
        this.pathApi = this.config.pathApi + 'attributeDefinition/';
    }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    canDelete(obj: any): Observable<any> {
        return this.http.post(`${this.pathApi}canDelete`, obj, {
            observe: 'response'
        });
    }
}